import React from 'react';
import i18n from '../../i18n';
import Button from "@material-ui/core/Button/Button";
import Card from "@material-ui/core/Card/Card";
import CardContent from "@material-ui/core/CardContent/CardContent";
import Typography from "@material-ui/core/Typography/Typography";
import Grid from "@material-ui/core/Grid/Grid";
import CardActions from "@material-ui/core/CardActions/CardActions";
import {withStyles} from "@material-ui/core/styles";
import Chip from "@material-ui/core/Chip/Chip";
import {FormattedDate, FormattedTime} from "react-intl";
import Icon from "@material-ui/core/Icon/Icon";
import Tooltip from "@material-ui/core/Tooltip/Tooltip";
import IconButton from "@material-ui/core/IconButton/IconButton";
import Divider from "@material-ui/core/Divider/Divider";
import EllipisWithTooltip from "../Formater/EllipsisWithTooltip";
import Paper from "@material-ui/core/Paper"
import Table from "@material-ui/core/Table"
import TableHead from "@material-ui/core/TableHead";
import TableBody from "@material-ui/core/TableBody";
import TableRow from "@material-ui/core/TableRow";
import TableCell from "@material-ui/core/TableCell";
import DeleteButton from "../Form/DeleteButton";

class ScheduleGrid extends React.Component {
    render() {
        const {subjects, classes} = this.props;

        return (
            <Paper className={classes.root}>
                <Table className={classes.table}>
                    <TableHead>
                        <TableRow>
                            <TableCell>{i18n.get('schedules.status')}</TableCell>
                            <TableCell>{i18n.get('schedules.day')}</TableCell>
                            <TableCell>{i18n.get('schedules.start')}</TableCell>
                            <TableCell>{i18n.get('schedules.end')}</TableCell>
                            <TableCell>{i18n.get('schedules.room')}</TableCell>
                            <TableCell>{i18n.get('schedules.lecturer')}</TableCell>
                            <TableCell>{i18n.get('schedules.topic')}</TableCell>
                            <TableCell> </TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {subjects.map(subject => (
                            <TableRow key={subject.id}>
                                <TableCell>
                                    {subject.status === 'A' &&
                                    <Icon className={classes.iconButtonIcon}>cancel</Icon>
                                    }
                                    {subject.status === 'B' &&
                                    <Icon className={classes.iconButtonCheck}>done_outline</Icon>
                                    }
                                    {subject.status === 'F' &&
                                    <Icon className={classes.iconButtonIcon}>help</Icon>
                                    }
                                    {subject.status === 'I' &&
                                    <Icon className={classes.iconButtonIcon}>person_pin</Icon>
                                    }
                                    {subject.status === 'U' &&
                                    <Icon className={classes.iconButtonWarning}>warning</Icon>
                                    }
                                     {subject.status}
                                </TableCell>
                                <TableCell>
                                    <Typography>
                                        <FormattedDate value={new Date(subject.day)}/>
                                    </Typography>
                                </TableCell>
                                <TableCell>
                                    {subject.start}
                                </TableCell>
                                <TableCell>
                                    {subject.end}
                                </TableCell>
                                <TableCell>
                                    {subject.room}
                                </TableCell>
                                <TableCell>
                                    {subject.lecturer.first_name + ' ' + subject.lecturer.last_name}
                                </TableCell>
                                <TableCell>
                                    {subject.topic}
                                </TableCell>
                                <TableCell>
                                    <DeleteButton
                                        href={`/schedules/${subject.id}`}
                                        confirmMessage={i18n.get('schedules.confirm_message')}
                                        successMessage={i18n.get('schedules.delete_success_message')}
                                        handleSuccess={() => {history.go(-1)}}
                                    />
                                    <Tooltip placement="bottom-end" title={i18n.get('schedules.edit')} classes={{tooltip : classes.popper}}>
                                        <IconButton href={`/schedules/${subject.id}/edit`} className={classes.iconButton}>
                                            <Icon className={classes.iconButtonIcon}>edit</Icon>
                                        </IconButton>
                                    </Tooltip>
                                </TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </Paper>
        )
    }
}

const styles = theme => ({
    cardContent: {
        minHeight: '150px'
    },
    cardActions: {
        padding: '4px 8px',
    },
    chip: {
        height: '24px',
    },
    chipLabel: {
        padding: '0 8px'
    },
    iconButton: {
        fontSize: 12,
        padding: '8px',
        opacity: 0.5,

        '&:hover': {
            color: theme.colors.primary,
            opacity: 1
        }
    },
    iconButtonIcon: {
        fontSize: 20
    },
    popper: {
        fontSize: 14,
        boxShadow: '2px 2px 3px rgba(0,0,0,0.3)'
    },
    iconButtonCheck: {
        color: 'lightgreen',
        marginRight: '5px',
    },
    iconButtonWarning: {
        color: 'yellow',
        marginRight: '5px',
    },
});

export default withStyles(styles)(ScheduleGrid);



// WEBPACK FOOTER //
// ./resources/assets/js/components/Schedules/ScheduleGrid.js